module.exports = __webpack_public_path__ + "img/e195d8834b5c34ff238d98899b4fec7f-cross.png";